@if (label) {
  <label
    class="ui-label ui-label--{{ labelSize }}"
    [ngClass]="{ 'ui-label--required': required }"
    >{{ label }}</label
  >
}

<div class="ui-input__container">
  @if (displayCountryDropdown) {
    <dx-select-box
      class="country-selector"
      [items]="countries"
      displayExpr="name"
      valueExpr="code"
      [value]="countryCode"
      (valueChange)="onCountryCodeChanged($event)"
      fieldTemplate="field"
      [disabled]="disabledCountryCode"
      [stylingMode]="stylingMode"
    >
      <div *dxTemplate="let data of 'field'">
        <div class="country-item">
          <dx-text-box
            [value]="data && data.flag + ' +' + data.countryPrefix"
            [readOnly]="true"
            [stylingMode]="stylingMode"
          ></dx-text-box>
        </div>
      </div>
      <div *dxTemplate="let data of 'item'">
        <div class="country-item">
          <span class="country-flag">
            {{ data.flag }}
          </span>
          <span class="country-name">
            {{ data.name }}
          </span>
        </div>
      </div>
    </dx-select-box>
  }

  <dx-text-box
    mode="tel"
    [placeholder]="placeholder"
    [value]="phoneNumber"
    [disabled]="disabled"
    (blur)="onBlur($event)"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    (keypress)="onKeyPress($event)"
    (valueChange)="onPhoneNumberChanged($event)"
    validationMessageMode="always"
    valueChangeEvent="blur change focusout paste"
    [hoverStateEnabled]="false"
    [stylingMode]="stylingMode"
  >
    <dx-validator>
      <dxi-validation-rule
        type="custom"
        [message]="invalidMessage"
        [validationCallback]="validateCellphoneFn"
      ></dxi-validation-rule>
    </dx-validator>
  </dx-text-box>
</div>

<ng-content />

@if (helper) {
  <p class="ui-helper">
    {{ helper }}
  </p>
}
